import React, { FunctionComponent } from "react";

import { Icon, IconColor, Layout, SpacingSize } from "@multiweb/reactComponents";
import { bemClassNames } from "@multiweb/reactUtils";
import { IconCode } from "@multiweb/types/contracts";
import { DropdownItemBaseProps } from "../../types";
import { DropdownIconText } from "../DropdownIconText";
import { DropdownItemWrapper } from "../DropdownItemWrapper";

const DROPDOWN_MENU_ITEM_SUBMENU = IconCode.uiChevronRight;
const classNames = bemClassNames("dropdown-list-item");

export const DropdownListItem: FunctionComponent<DropdownItemBaseProps> = ({ clickAction, ...restProps }) => {
    return (
        <DropdownItemWrapper {...{ clickAction }} {...restProps}>
            <div className={classNames()}>
                <DropdownIconText iconCode={clickAction?.icon} value={clickAction?.text} disabled={clickAction?.disabled} {...restProps} />
                <Layout spacingSize={SpacingSize.xs} spacingSizeRight={SpacingSize.s}>
                    <Icon iconCode={DROPDOWN_MENU_ITEM_SUBMENU} color={IconColor.default} />
                </Layout>
            </div>
        </DropdownItemWrapper>);
};
